import PATHS from '../constants';

function fetchTeam() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.ABOUT_US_TEAM, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchTeam;